module.exports = __webpack_public_path__ + "images/fa-lp-sl-m-martin-ganchev.webp";